module.exports = __webpack_public_path__ + "static/media/facebook-author.bbb12ffb.svg";